<template>
  <div>
    <div v-if="editAccount">
      <b-tabs pills card>
        <b-tab :title="$t('Main')" active>
          <b-form-group label-align="right" :label="$t('Account ID')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="number" v-model="editAccount.account_id" disabled/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Credit')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="number" v-model="editAccount.credit" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Balance')" label-cols="4" label-cols-xl="2" label-cols-md="4">
          <b-input-group>
            <b-form-input type="number" v-model="editAccount.balance" disabled></b-form-input>
            <b-input-group-append>
              <md-button class="md-raised" @click="showChangeBalance" style="margin-top:0px">{{ $t('Change balance') }}</md-button>
            </b-input-group-append>
          </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('VAT, %')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="number" v-model="vatRate" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('External ID')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="text" v-model="editAccount.external_id" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Sale tax rate, %')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="number" v-model="saleTaxRate" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Contract number')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="text" v-model="editAccount.contract_number" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Signature date')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <md-button
            style="margin-top:0rem"
            v-if="editAccount.signature_date==0"
            class="md-raised"
            @click="editAccount.signature_date = new Date()/1000">{{$t('Set value')}}</md-button>
            <flat-picker v-else
              @onDateChanged="(unixDate) => {editAccount.signature_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(editAccount.signature_date ? editAccount.signature_date : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Contract close date')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <md-button
            style="margin-top:0rem"
            v-if="editAccount.contract_close_date == 0"
            class="md-raised"
            @click="editAccount.contract_close_date = new Date()/1000">{{$t('Set value')}}</md-button>
            <flat-picker v-else
              @onDateChanged="(unixDate) => {editAccount.contract_close_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(editAccount.contract_close_date ? editAccount.contract_close_date : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('IPTV settings')">
          <b-form-group label-align="right" :label="$t('Irdeto IPTV access card')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="text" v-model="editAccount.irdeto_access_card_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Queries irdeto IPTV access card')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-input-group>
              <b-form-select type="number" v-model="curQuerie" :options="optionsQueries"/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="querieIrdetoCard">{{ $t('Create') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Irdeto IPTV STB')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-input type="text" v-model="editAccount.irdeto_stb_serial_number"/>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('State settings')">
          <b-form-group label-align="right" :label="$t('Unlimited mode')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-checkbox @change="onUnlimitedClick" switch size="lg" v-model="editAccount.unlimited"/>
          </b-form-group>
          <b-form-group label-align="right" id="currenciesInputGroup" :label="$t('Internet')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-select id="blocks" :options="internet" required v-model="editAccount.int_status"/>
            <b-form-checkbox switch v-model="editAccount.auto_enable_inet">{{ $t('Auto enable internet') }}</b-form-checkbox>
          </b-form-group>
          <b-form-group label-align="right" id="currenciesInputGroup" :label="$t('Block')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-form-select id="blocks" @change="blockChanged" :options="blocks_to_show" required v-model="editAccount.block_type"/>
          </b-form-group>
          <b-form-group v-show="editAccount.block_type != 0" label-align="right"  :label="$t('Active Block')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-row>
              <b-col>
                <b-form-group :disabled="activeBlockedAccount"  style="margin-left:7.7rem;" label-cols-sm="2" :label="$t('Since')">
                  <flat-picker ref="dpstart"
                  style="width: 165px;height: 35px;"
                  @onDateChanged="onChangedDateStart"
                  @ready="dpMountedStart"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group :disabled="activeBlockedAccount" style="margin-left:1rem;"  label-cols-sm="2" :label="$t('Until')">
                  <flat-picker ref="dpend"
                  style="width: 165px;height: 35px;"
                  @onDateChanged="onChangedDateEnd"
                  @ready="dpMountedEnd"
                  />
                </b-form-group>
              </b-col>
              <b-col label-cols-sm="1" style="margin-left:-8rem;margin-top:0.5rem;"></b-col>
            </b-row>
          </b-form-group>
          <div :key="rerenderBlocks">
          <b-form-group v-for="(item, key) in editAccount.blocks_info" :key="key" label-align="right"  :label="$t('Future Block')" label-cols="8" label-cols-xl="2" label-cols-md="4">
            <b-row>
              <b-col>
                <b-form-group  style="margin-left:7.7rem;" label-cols-sm="2" :label="$t('Since')">
                  <flat-picker
                  style="width: 165px;height: 35px;"
                  :item="item"
                  :isDisabled="true"
                  @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(item.start_date ? item.start_date : new Date()/1000 ).toDate())}"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group disabled  style="margin-left:1rem;"  label-cols-sm="2" :label="$t('Until')">
                  <flat-picker
                  style="width: 165px;height: 35px;"
                  :item="item"
                  :isDisabled="true"
                  @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(item.expire_date ? item.expire_date : new Date()/1000 ).toDate())}"
                  />
                </b-form-group>
              </b-col>
              <b-col style="margin-left:-8rem;margin-top:0.5rem;">
                <i >{{typeToStr(item.block_type)}}</i>
                <i style="margin-left:2rem" @click.stop="deleteBlock(item)" class="danger fa fa-trash-alt fa-lg"/>
              </b-col>
            </b-row>
          </b-form-group>
        </div>
        </b-tab>
        <b-tab :title="$t('Groups')">
          <b-form-group label-align="right" :label="$t('Accounts groups')" label-cols="4" label-cols-xl="2" label-cols-md="4">
            <b-row>
              <b-col style="margin-top:10px" >
                <b-select size="sm" v-model="accGroupID" :options="groupsOption"/>
              </b-col>
              <b-col>
                <md-button class="md-raised" :disabled="accGroupID===0" @click="addGroup">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>

          <basic-table small striped hover
          :items="accGroups"
          :fields="groupsFields"
          @ClickOnDeleteButton="ClickOnDeleteButton"
          isDelete="true">
          </basic-table>
          </b-form-group>

        </b-tab>
      </b-tabs>
      <b-row style="padding-bottom:10px">
        <b-col cols="9">
        </b-col>
        <b-col cols="2">
          <b-row>
            <b-col cols="6">
              <md-button @click.stop="close"  >{{ $t('Cancel') }}</md-button>
            </b-col>
            <b-col cols="6">
              <md-button @click.stop="save" class="md-raised">{{ $t('Save') }}</md-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <b-modal hide-footer  ref="ChangeBalance" :title="$t('Correct balance')">
      <b-form-group label-align="right" :label="$t('Amount')" label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-input type="number" @change="changeBalanceDelta" v-model="balanceDelta" ></b-form-input>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('New balance')" label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-input type="text" @change="changeNewBalance" v-model="balanceNewBalance" ></b-form-input>
      </b-form-group>
          <b-form-textarea
            id="textarea"
            v-model="changeBalanceComment"
            placeholder="Comment..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        <modal-ok-cancel @save="onChangeBalance" @cancel="$refs.ChangeBalance.hide()" size="md"/>
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    accountInfo: null,
    currentRow: null
  },
  data () {
    return {
      activeBlockedAccount: false,
      rerenderBlocks: 0,
      dateFormat: 'MMM D, YYYY HH:mm:ss',
      accGroupID: 0,
      accGroups: [],
      accGroup: {
        group_id: 0,
        accounts: []
      },

      groupsFields: [
        {key: 'group_id', label: 'ID', sortable: true},
        {key: 'group_name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions')}
      ],
      vatRate: 0,
      saleTaxRate: 0,
      balanceDelta: '',
      balanceNewBalance: '',
      changeBalanceComment: '',
      curQuerie: 1,
      IPTVcard: {
        'account_id': 0,
        'access_card_number': 0
      },
      editAccessCardNumber: 0,
      editAccount: null,
      internet: [{'text': this.$i18n.t('On'), 'value': 1}, {'text': this.$i18n.t('Off'), 'value': 0}],
      blocks_to_show: [{'text': this.$i18n.t('Active'), 'value': 0}, {'text': this.$i18n.t('Admin block'), 'value': 256}],
      block_user: {'text': this.$i18n.t('User block'), 'value': 1},
      block_system: {'text': this.$i18n.t('System block'), 'value': 16},
      optionsQueries: [
        {text: this.$i18n.t('Activate card'), value: 1},
        {text: this.$i18n.t('Deactivate card'), value: 2},
        {text: this.$i18n.t('Pair chipset'), value: 3},
        {text: this.$i18n.t('Unpair all chipsets'), value: 4},
        {text: this.$i18n.t('Reset PIN'), value: 5},
        {text: this.$i18n.t('Synchronize'), value: 6}
      ]
    }
  },
  async mounted () {
    this.$store.dispatch('Users/GET_ACCOUNTS_GROUPS')
    this.load()
  },
  watch: {
    currentRow: function (val) {
      this.load()
    },
    vatRate: function (Val) {
      this.editAccount.vat_rate = (Number(Val) / 100.0).toFixed(4)
    },
    saleTaxRate: function (Val) {
      this.editAccount.sale_tax_rate = (Number(Val) / 100.0).toFixed(4)
    }

  },
  methods: {
    async onUnlimitedClick () {
      let body = this.verifyEditAccount()
      if (body === {}) {
        return
      }
      this.prepareEditAccount()
      let response = this.$store.dispatch('Users/UPDATE_ACCOUNT', this.editAccount)
      response.then(resp => {
        if (resp.status !== 200) {
          this.editAccount.unlimited = !this.editAccount.unlimited
          this.$root.$emit('makeToasts', 'danger', resp.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      }).catch(e => {
        this.$root.$emit('makeToasts', 'danger', 'Error', 'Error')
        this.editAccount.unlimited = !this.editAccount.unlimited
      })
    },
    blockChanged (val) {
      if (val === 256) {
        this.editAccount.block_start = this.$root.getMomentWithTZDelta(moment().unix()).unix()
      }
    },
    typeToStr (type) {
      switch (type) {
        case -1:
          return this.$i18n.t('No block')
        case 1:
          return this.$i18n.t('System block')
        case 2:
          return this.$i18n.t('Admin block')
        case 3:
          return this.$i18n.t('User block')
      }
    },
    deleteBlock (item) {
      this.$store.dispatch('Users/DELETE_USERS_BLOCK', item.id)
      this.editAccount.blocks_info = this.editAccount.blocks_info.filter(el => { return el.id !== item.id })
      this.rerenderBlocks += 1
    },
    ClickOnDeleteButton (row) {
      this.accGroups = this.accGroups.filter(el => {
        return el.group_id !== row.group_id
      })
    },
    addGroup () {
      this.accGroups = this.accGroups.filter(el => {
        return el.group_id !== this.accGroupID
      })
      let name = ''
      this.groupsOption.forEach(el => {
        if (el.value === this.accGroupID) name = el.text
      })
      this.accGroups.push({group_id: this.accGroupID, group_name: name})
    },
    changeBalanceDelta (val) {
      if (val === '' || val.includes(',')) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Unsupported value; For float number use `.`(dot) notation! (example : 12.45)'), 'Error')
      }
      let balance = +(this.editAccount.balance)
      let delta = +(val)
      this.balanceNewBalance = balance + delta
      this.balanceNewBalance = Number(this.balanceNewBalance.toFixed(2))
    },
    changeNewBalance (val) {
      if (val === '' || val.includes(',')) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Unsupported value; For float number use `.`(dot) notation! (example : 12.45)'), 'Error')
      }
      let balance = +(this.editAccount.balance)
      let newBalance = +(val)
      this.balanceDelta = newBalance - balance
      this.balanceDelta = Number(this.balanceDelta.toFixed(2))
    },
    dpMountedStart (dp) {
      let date = this.editAccount.block_start ? this.$root.getMomentWithTZDelta(this.editAccount.block_start).toDate() : this.$root.getMomentWithTZDelta(new Date() / 1000).toDate()
      dp.setDate(date)
    },
    dpMountedEnd (dp) {
      let date = this.editAccount.block_end ? this.$root.getMomentWithTZDelta(this.editAccount.block_end).toDate() : this.$root.getMomentWithTZDelta(new Date() / 1000).toDate()
      dp.setDate(date)
    },
    onChangedDateStart (date) {
      let changedDate = date
      let currentDate = moment().unix()
      if (changedDate + 30 < currentDate) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Set block start date earlier than current is forbidden'), 'Error')
        this.$refs.dpstart.setDate(new Date(currentDate * 1000))
        return
      }
      this.editAccount.block_start = changedDate
    },
    onChangedDateEnd (date) {
      let changedDate = date
      if (changedDate < this.editAccount.block_start) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Set block end date earlier than start date is forbidden'), 'Error')
        this.$refs.dpend.setDate(new Date())
        return
      }
      this.editAccount.block_end = changedDate
    },
    showChangeBalance () {
      this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Float has dot format (example 12.45)'), 'Warning')
      this.$root.$emit('makeToasts', 'warning', this.$i18n.t('This is danger function. Make sure that youre know what you do.'), 'Warning')
      this.$refs.ChangeBalance.show()
    },
    async onChangeBalance () {
      await this.$store.dispatch('Users/CHANGE_BALANCE', {account_id: this.editAccount.account_id,
        new_balance: Number(this.balanceNewBalance),
        comment: this.changeBalanceComment}).then(result => {
        if (result.status === 200) {
          this.$emit('refreshTable')
        } else {
          this.$root.$emit('makeToasts', 'danger', result.data.error, 'Error')
        }
        this.$refs.ChangeBalance.hide()
      })
    },
    async querieIrdetoCard () {
      switch (this.curQuerie) {
        case 1:
          await this.$store.dispatch('Users/GET_IRDETO_ACTIVATE', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_ACTIVATE'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to activate Irdeto CAS service', 'Error')
            }
          })
          break
        case 2:
          await this.$store.dispatch('Users/GET_IRDETO_DEACTIVATE', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_DEACTIVATE'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to deactivate Irdeto CAS service', 'Error')
            }
          })
          break
        case 3:
          await this.$store.dispatch('Users/GET_IRDETO_PAIR_CHIPSET', this.editAccount).then(response => {
            if (this.$store.getters['Users/IRDETO_PAIR_CHIPSET'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to pairChipSet Irdeto CAS service', 'Error')
            }
          })
          break
        case 4:
          await this.$store.dispatch('Users/GET_IRDETO_UNPAIR_ALL_CHIPSET', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_UNPAIR_ALL_CHIPSET'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to unpairChipSet Irdeto CAS service', 'Error')
            }
          })
          break
        case 5:
          await this.$store.dispatch('Users/GET_IRDETO_RESET_PIN', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_RESET_PIN'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to overwriteParentalPinCode Irdeto CAS service', 'Error')
            }
          })
          break
        case 6:
          await this.$store.dispatch('Users/GET_IRDETO_SYNCHRONIZE', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_SYNCHRONIZE'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to synchronize Irdeto CAS service', 'Error')
            }
          })
          break
      }
    },
    async load () {
      if (this.accountInfo) {
        this.editAccount = this.accountInfo
      } else {
        this.editAccount = JSON.parse(JSON.stringify(this.currentRow))
      }
      await this.$store.dispatch('Users/GET_ACCOUNTS_GROUPS_BY_AID', this.editAccount).then(resp => {
        this.accGroups = this.$store.getters['Users/ACCOUNTS_GROUPS_LIST']
      })
      await this.$store.dispatch('Users/GET_BLOCKS_INFO', this.editAccount.account_id).then(response => {
        this.editAccount.blocks_info = this.$store.getters['Users/ACCOUNTS_BLOCKS'].blocks_info
      })
      this.vatRate = Number(this.editAccount.vat_rate * 100).toFixed(2)
      this.saleTaxRate = Number(this.editAccount.sale_tax_rate * 100).toFixed(2)
      this.editAccessCardNumber = JSON.parse(JSON.stringify(this.editAccount.access_card_number))
      this.activeBlockedAccount = this.editAccount.block_type > 0
      switch (Number(this.editAccount.block_type)) {
        case 16 : {
          this.blocks_to_show.push(this.block_system)
          break
        }
        case 1 : {
          this.blocks_to_show.push(this.block_user)
          break
        }
      }
      this.editAccount.auto_enable_inet = (this.editAccount.flags === 8)

      if (this.editAccount.block_start && this.editAccount.block_end) {
        this.editAccount.block_start = this.editAccount.block_start
        this.$refs.dpstart.setDate(new Date(this.editAccount.block_start * 1000))
        this.editAccount.block_end = this.editAccount.block_end
        this.$refs.dpend.setDate(new Date(this.editAccount.block_end * 1000))
      }
    },
    close () {
      this.$emit('close', null)
    },
    verifyEditAccount () {
      if (typeof (this.editAccount.block_start) === 'number') {
        this.editAccount.block_start = this.editAccount.block_start ? Number(this.editAccount.block_start) : 0
      } else {
        this.editAccount.block_start = this.editAccount.block_start ? Date.parse(Number(this.editAccount.block_start)) : 0
      }
      if (typeof (this.editAccount.block_end) === 'number') {
        this.editAccount.block_end = this.editAccount.block_end ? Number(this.editAccount.block_end) : 0
      } else {
        this.editAccount.block_end = this.editAccount.block_end ? Date.parse(Number(this.editAccount.block_end)) : 0
      }
      let body = {account_id: this.editAccount.account_id, groups: []}
      for (let el of this.accGroups) {
        body.groups.push(el.group_id)
      }
      let isBlocked = this.editAccount.block_type === 256
      if (isBlocked &&
      this.editAccount.block_end < this.editAccount.block_start) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Set block end date earlier than start date is forbidden'), 'Error')
        return {}
      }
      if (isBlocked &&
      (this.editAccount.block_start + 45) < (moment().unix())) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Set block start date earlier than current is forbidden'), 'Error')
        return {}
      }
      return body
    },
    prepareEditAccount () {
      this.editAccount.balance = Number(this.editAccount.balance)
      this.editAccount.credit = Number(this.editAccount.credit)
      this.editAccount.block_type = Number(this.editAccount.block_type)
      this.editAccount.vat_rate = Number(this.editAccount.vat_rate)
      this.editAccount.sale_tax_rate = Number(this.editAccount.sale_tax_rate)
    },
    save () {
      let body = this.verifyEditAccount()
      if (body === {}) {
        return
      }
      this.$store.dispatch('Users/LINK_GROUP_TO_ACC', body)
      this.prepareEditAccount()
      let response = this.$store.dispatch('Users/UPDATE_ACCOUNT', this.editAccount)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/CREATE_ACCOUNT_SEARCH', { 'value': '' })
          this.$emit('close', null)
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    groupsOption () {
      let res = []
      for (let el of this.$store.getters['Users/ACCOUNTS_GROUPS']) {
        res.push({value: el.group_id, text: el.group_name})
      }
      return res
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accounts/detail/main.vue